export default {
  formActions: {
    addPlaceInput: 'Adăugați intrarea locului',
    clearRoute: 'Traseu liber',
    reverseRoute: 'Rută inversă',
    roundTrip: 'Călătorie dus-întors',
    toggleRoundTrip: 'Comutați călătoria dus-întors',
  }
}
